import React, { memo, FC } from 'react';
import NextImage from 'next/image';
import dynamic from 'next/dynamic';

import {
  VideoPreview,
  PlayIconWrapper,
  IFrameWrapper,
  Videos as UIVideos,
} from './videos.styles';
import { useVideos, extraDetailsDataWithDefault } from './videos.hook';
import { BaseDialogProps } from '@keaze/web/components/baseDialog';
import { VideosProps } from './videos.types';

type RenderDialogArgs = {
  title?: string;
  description?: string;
  embedCode: string;
  open: boolean;
  onClose: () => void;
};

type RenderDialog = (args: RenderDialogArgs) => JSX.Element;

const DynamicBaseDialog = dynamic<BaseDialogProps>(() =>
  import('@keaze/web/components/baseDialog').then((model) => model.BaseDialog)
);

const renderDialog: RenderDialog = ({
  title,
  description,
  embedCode,
  open,
  onClose,
}) => (
  <DynamicBaseDialog
    title={title}
    description={description}
    open={open}
    onClose={onClose}
  >
    <IFrameWrapper
      dangerouslySetInnerHTML={{
        __html: embedCode,
      }}
    />
  </DynamicBaseDialog>
);

export const Videos: FC<VideosProps> = memo(
  ({ title, listing, description, videos, onChange }) => {
    const { isVideoModal, embedCode, onVideoClick } = useVideos({
      listing,
      videos,
      onChange,
    });

    return (
      <UIVideos container>
        {videos.map(({ url, extraDetails }) => {
          const { thumbnailUrl, videoId } = extraDetailsDataWithDefault(
            extraDetails
          );

          return (
            <VideoPreview
              key={url}
              src={thumbnailUrl}
              onClick={() => onVideoClick(videoId)}
            >
              <PlayIconWrapper>
                <NextImage src="/svg/play.svg" layout="fill" priority />
              </PlayIconWrapper>
            </VideoPreview>
          );
        })}
        {renderDialog({
          title,
          description,
          embedCode,
          open: isVideoModal,
          onClose: () => onVideoClick(),
        })}
      </UIVideos>
    );
  }
);
